exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-9a50f66a]{text-decoration:none;color:#000}.tabs[data-v-9a50f66a]{width:100%;height:30px;padding:0;margin:auto}.sureTab[data-v-9a50f66a]{border-bottom:4px solid #00b3c1}.li-tab[data-v-9a50f66a]{width:50%;height:100%;display:inline-block;text-align:center}.folding-box[data-v-9a50f66a]{border:.5px solid #d9dde1;width:35px;height:30px;line-height:30px;text-align:center;font-size:20px}.folding-close[data-v-9a50f66a]{display:none}.video-list[data-v-9a50f66a]{border:1px solid gray}.video-list thead[data-v-9a50f66a]{font-size:15px}.video-list tbody[data-v-9a50f66a]{font-size:10px}.question-reply thead[data-v-9a50f66a]{background-color:ivory;font-size:15px}.question-reply tbody[data-v-9a50f66a]{font-size:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9a50f66a","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Personal/MyQuestion.vue
// module id = H3t5
// module chunks = 1